import { useTranslation } from 'react-i18next'

const ChangeLanguageDropdown = () => {
    const { i18n } = useTranslation()
    const lang = i18n.language || 'th'

    const languages = [
        { code: 'th', label: 'ไทย', shortLabel: 'TH' },
        { code: 'en', label: 'English', shortLabel: 'EN' }
    ]

    const setLang = (language) => {
        i18n.changeLanguage(language)
        localStorage.setItem('trans_lang', language)
    }

    return (
        <div className="dropdown d-inline-block">
            <button
                type="button"
                className="position-relative dropdown-toggle"
                data-bs-toggle="dropdown"
            >
                <img
                    src={`/assets/img/svg/flag_${lang}.svg`}
                    style={{ width: 25, marginBottom: 4 }}
                    alt="flag"
                />
                <span className="text-black ms-1">
                    {languages.find(l => l.code === lang)?.shortLabel || 'TH'}
                </span>
            </button>
            <ul className="dropdown-menu">
                {languages.map((_l) => (
                    <li key={_l.code}>
                        <button
                            className="dropdown-item d-flex align-items-center"
                            onClick={() => setLang(_l.code)}
                        >
                            <img
                                src={`/assets/img/svg/flag_${_l.code}.svg`}
                                className="me-2"
                                alt={_l.code.toUpperCase()}
                                style={{ width: 25 }}
                            />
                            {_l.label}
                        </button>
                    </li>
                ))}
            </ul>
        </div>
    )
}

export default ChangeLanguageDropdown;
